import React from "react";
import { Empty } from "antd";
import "./index.less";

export default ({ ...props }) => {
  return (
    <Empty description="No Data Found" className="empty-container" {...props} />
  );
};
